<script setup lang="ts">
import { gaiaNeutral, gaiaShellPadding } from '../../themes/tokens';

const border = gaiaNeutral.borderMuted;
const bg = gaiaNeutral.surface;
// The page's shared left/right edge — a full-bleed shell's title row lines up
// with the breadcrumb because both read it from here.
const pageX = gaiaShellPadding.pageX;
</script>

<template>
  <!-- The 56px page top bar from the CM mocks — breadcrumb (default slot) on
       the left, #actions right-aligned. Pages don't mount it themselves: the
       layouts (layout/Layout.vue, WizardLayout, WorkspaceLayout) render it
       around their #breadcrumb slot, so every page gets the same bar. Its inset
       is `pageX`, the same edge the content column below it sits on. -->
  <n-flex align="center" justify="space-between" :size="12" :wrap="false" class="gaia-topbar">
    <slot />
    <n-flex v-if="$slots.actions" align="center" :size="8" :wrap="false">
      <slot name="actions" />
    </n-flex>
  </n-flex>
</template>

<style scoped>
/* Fixed bar height and the page rule beneath it — neither is themeable. */
.gaia-topbar {
  height: 56px;
  flex: none;
  padding: 0 v-bind(pageX);
  background: v-bind(bg);
  border-bottom: 1px solid v-bind(border);
}
</style>
